<template lang="pug">
header
  .top
    router-link.left.brand(to='/')
      img.left-img(:src='logoImage')
      h1.left-h1 #[strong #[span.red.nav NAV]]Legal #[span.red Notaries]
    .right
      p.right-p Call Us Today: #[span.red.phone {{ $store.state.phone }}]
  nav.bottom
    router-link.bottom-a(to='/') Home
    span(@mouseenter='dropdown = true' @mouseleave='dropdown = false' @click='dropdown = false')
      router-link.bottom-a(
          :to="{name: 'NotariesAll'}"
          ) Find&nbsp;A&nbsp;Notary
      //- ul.dropdown
      ul.dropdown(v-if='dropdown')
        li.dropdown-li(v-for='province in $store.state.provinces' @click='goTo(province.province.toLowerCase())')
          a.dropdown-li-a(:href='to(province.province.toLowerCase())' @click.prevent='') {{ province.province }}
    router-link.bottom-a(to='/services') Services
    router-link.bottom-a(to='/about') About
    router-link.bottom-a(to='/contact') Contact


</template>

<script>
import logo from '@/assets/images/logo.png'
export default {
  data() {
    return {
      dropdown: false,
      logoImage: logo
    }
  },
  methods: {
    to(province) {
      return '/notaries/' + province.replace(/ /g, '_').replace(/\./g, ',')
    },
    goTo(province) {
      this.$router.push({
        name: 'NotariesProvince',
        params: { province: province.replace(/ /g, '_').replace(/\./g, ',') }
      })
    }
  }
}
</script>

<style lang="scss">
.dropdown {
  display: none;
  list-style-type: none;
  margin: 0;
  padding: 15px 0;
  position: absolute;
  background: #f8f8f8;
  border-radius: 15px;
  box-shadow: 1px 2px 5px rgba(#333, 0.5);
  z-index: 10000000000;
  &-li {
    position: relative;
    height: 25px;
    min-width: 268px;
    &:hover {
      background: darken(#f8f8f8, 25%);
      cursor: pointer;
    }
    &-a {
      text-decoration: none;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 2px 20px;
      color: #000;
      font-size: 16px;

    }
  }
  @media only screen and (min-width: 768px) {
    display: block;
  }
}
.brand {
  &,
  &:hover,
  &:visited,
  &:active {
    text-decoration: none;
    color: #333;
  }
}
.top {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: space-between;
  // border-bottom: 1px solid rgba(#333, 0.3);
  margin: 15px;
}
.left {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: center;
  &-img {
    height: 50px;
  }
  &-h1 {
    font-size: 1.5rem;
    line-height: 50px;
    font-weight: 300;
    font-family: 'Poppins', sans-serif;
    .nav {
      padding-right: 2px;
    }
  }
}
.right-p {
  font-weight: 300;
  font-size: 21px;
  line-height: 23px;
}
.bottom {
  padding-bottom: 25px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  overflow-x: auto;

  // box-shadow: inset 2px 2px 15px rgba(0,0,0,0.4);
  padding: 0;
  background: #000;
  &-a {
    color: #333;
    color: #fff;
    text-decoration: none;
    padding: 15px;
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// Navbar.vue?db8e6c80